// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1QeMj","option":"styles_option__3d7Uy","selected":"styles_selected__1ZkrA"};